module.exports = __webpack_public_path__ + "static/media/Simran_Veer.0b660f9e.jpg";